import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ContractConditions } from '../../model/contract-conditions.model';

@Component({
    selector: 'app-contract',
    templateUrl: './contract.component.html',
    styleUrls: ['./contract.component.scss'],
    standalone: false
})
export class ContractComponent {
  @Input() conditions: ContractConditions[];
  @Output() contractSelectedEvent = new EventEmitter<ContractConditions>();
  contractSelect: string;

  selectContract(contract: ContractConditions): void {
    this.contractSelectedEvent.emit(contract);
  }

  customSearchFn(term: string, item: any): boolean {
    term = term.toLowerCase();
    return (
      item.contractName?.toLowerCase().includes(term) ||
      item.contractId?.toLowerCase().includes(term)
    );
  }
}
